import HashtagIcon from "assets/icons/Hashtag";
import BasicTextInput from "components/BasicInputs/BasicTextInput";
import ContainedTabs from "components/Tabs/Tabs3";
import { useFormikContext } from "formik";
import { useState } from "react";

export default function AccountingCode() {
  const [disabled, setDisabled] = useState(true);
  const [value, setValue] = useState<string | number>();
  const data = useFormikContext<MaterialFormulaData>();
  return (
    <div className="flex items-center gap-4 p-4">
      <BasicTextInput
        disabled={disabled}
        style={{ padding: "0px 0px 0px 12px" }}
        suffix={
          <div
            className={`flex items-center justify-center gap-2 p-2 border-l border-dashed ${
              disabled ? "text-slate-300" : " text-slate-500"
            }`}
          >
            <HashtagIcon color={disabled ? "#b0bec5" : "#607d8b"} style={{ transform: "scale(0.9)" }} />
            <span>کد</span>
          </div>
        }
        val={data.values.accountingCode}
        onChange={(val) => {
          setValue(val);
          data.setFieldValue("accountingCode", val);
        }}
      />
      <ContainedTabs
        tabs={[
          { label: "اتوماتیک", activeColor: "#1062D0" },
          { label: "دستی", activeColor: "#CB0B0B" },
        ]}
        onChange={(val) => {
          data.setFieldValue("accountingCode", val === 0 ? undefined : value);
          setDisabled(val === 0);
        }}
        size={2}
        minWidth={70}
      />
    </div>
  );
}
